import type { RechargeSettingsSummary, RechargeSettingsUpdateBody } from '@flux/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/lib/query/keys.js';
import { toast } from '@/lib/toast.js';
import { updateRechargeSettings } from './api-recharge.js';

export const RECHARGE_SAVED_MESSAGE = 'Réglages Recharge enregistrés';

/**
 * Enregistre une section des réglages Recharge (`06` §8.6) : le résumé
 * renvoyé remplace le cache, et la liste des webhooks est relue (token,
 * client secret et modes changent les topics manquants).
 */
export function useSaveRechargeSettings(onSaved?: (summary: RechargeSettingsSummary) => void) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: RechargeSettingsUpdateBody) => updateRechargeSettings(body),
    onSuccess: (summary) => {
      queryClient.setQueryData(queryKeys.rechargeSettings.summary(), summary);
      void queryClient.invalidateQueries({ queryKey: queryKeys.rechargeSettings.webhooks() });
      toast.success(RECHARGE_SAVED_MESSAGE);
      onSaved?.(summary);
    },
    onError: (error: unknown) => {
      toast.fromError(error);
    },
  });
}
